import Typography from "@mui/material/Typography";
import { useI18n } from "@/i18n/I18nProvider";
import { colors } from "@/utils/const";

export default function TitleWithImgFirst({ title, h1 }) {
  const { locale } = useI18n();

  return (
    <Typography
      component={h1 ? h1 : "h3"}
      sx={{
        fontSize: "32px",
        color: colors.navy_blue,
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        position: "relative",
        pl: locale === "ar" ? 0 : 1.5,
        pr: locale === "ar" ? 1.5 : 0,
        "&::before": {
          content: '""',
          display: "block",
          backgroundImage:
            'url("https://contact-eg.s3.us-east-2.amazonaws.com/leads/blogs_line.webp")',
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          width: "4px",
          height: "40px",
          position: "absolute",
          left: locale === "ar" ? "unset" : 0,
          right: locale === "ar" ? "0px" : "unset",
          top: "10%",
        },
      }}
    >
      {title}
    </Typography>
  );
}
